import React from 'react';
import AdminLogin from '../components/Admin/Auth/AdminLogin';

const AdminLoginPage = () => {
  return <AdminLogin />;
};

export default AdminLoginPage;
